<template>
  <a-card>
    <div style="text-align: right;">
      <span class="ant-descriptions-title" style="float: left; margin-top: 5px;">
        <a-icon type="appstore" /> List Employee
      </span>
      <div slot="extra">
        <!--        <a-button type="primary" @click="() => (visibleAddUser = true)">-->
        <!--          <a-icon type="user-add" />-->
        <!--          Add Employee & User from Azure AD-->
        <!--        </a-button>-->
        <a-button icon="export" @click="showExport">
          Export
        </a-button>
        {{ " " }}
        <a-button type="primary" @click="() => (visibleAddEmployee = true)">
          <a-icon type="plus" /> Add Employee only
        </a-button>
      </div>
    </div>

    <a-drawer v-if="visibleAddUser" title="Add Employee & User from Azure AD" placement="right"
      :visible="visibleAddUser" @close="() => (visibleAddUser = false)" :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }">
      <AddUser :closeDrawer="() => (visibleAddUser = false)" :updateListAfterCreated="updateListAfterCreated"
        style="margin-bottom: 10px;" />
    </a-drawer>

    <a-drawer v-if="visibleAddEmployee" title="Add Employee" placement="right" :visible="visibleAddEmployee"
      @close="() => (visibleAddEmployee = false)" :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }">
      <AddEmployee :closeDrawer="() => (visibleAddEmployee = false)" :updateListAfterCreated="updateListAfterCreated"
        style="margin-bottom: 10px;" />
    </a-drawer>

    <a-drawer v-if="visibleUpdateAnnualLeave" title="Update annual leave" placement="right"
      :visible="visibleUpdateAnnualLeave" @close="() => setVisibleUpdateAnnualLeave()" :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }">
      <EditLeaveDay :annualLeaveDay="employee.annualLeaveDay" :employee="employee"
        :refreshEmployeeAfterLeaveAnualUpdated="refreshEmployeeAfterLeaveAnualUpdated
          " :close="setVisibleUpdateAnnualLeave" />
    </a-drawer>

    <a-table :pagination="{
      current: currentPage,
      onChange: (page) => {
        this.currentPage = page;
      },
    }" bordered :columns="columnEmployee" :data-source="listEmployee" rowKey="id" :loading="loading" size="small"
      :scroll="{ y: 'calc(100vh - 400px)', x: 'calc(100vw - 100px)' }" class="employee-table">
      <div slot="title">
        <a-row :gutter="[8, 8]">
          <a-col :sm="24" :md="10">
            <div class="search-employee-content">
              <a-input v-model="keySearch" placeholder="Search..." style="width: 100%;" @change="onFilter" />
            </div>
          </a-col>
          <a-col :sm="24" :md="14" style="text-align: right;">
            <FilterListDrawer :filter="filter" :isDisabledResetFilter="isDisabledResetFilter" :onFilter="onFilter"
              :resetFilter="resetFilter" :setFilterItem="setFilterItem" />
          </a-col>
        </a-row>
      </div>

      <div slot="code" slot-scope="text, record">
        <a @click="goToListEmployee(record)">{{ record.code }}</a>
      </div>

      <div slot="fullname" slot-scope="text, record">
        <a @click="goToListEmployee(record)">{{ record.fullname }}</a>
      </div>

      <div slot="gender" slot-scope="text, record">
        <span v-if="record.gender === 'NONE'">Other </span>
        <span v-if="record.gender === 'MALE'">Male </span>
        <span v-if="record.gender === 'FEMALE'">Female</span>
      </div>

      <div slot="startedDate" slot-scope="text">
        <span>{{ text | formatDate }} </span>
      </div>
      <div slot="birthday" slot-scope="text, record">
        <span>{{ record.birthday | formatDate }} </span>
      </div>
      <div slot="original" slot-scope="text, record">
        <span>
          {{ (text / getDurationShiftEmployee(record)) | numParseFloat(2) }}
        </span>
      </div>
      <div slot="default" slot-scope="text, record">
        <span>
          {{ (text / getDurationShiftEmployee(record)) | numParseFloat(2) }}
        </span>
      </div>
      <div slot="usedInYear" slot-scope="text, record">
        <span>
          {{ (text / getDurationShiftEmployee(record)) | numParseFloat(2) }}
        </span>
      </div>
      <div slot="remain" slot-scope="text, record">
        <span>
          {{ (text / getDurationShiftEmployee(record)) | numParseFloat(2) }}
        </span>
      </div>

      <div slot="action" slot-scope="text, record" style="text-align: center;">
        <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="goToListEmployee(record)">
              Open Detail
            </a-menu-item>
            <a-menu-item key="2" @click="goToListEmployeeInNewTab(record)">
              Open In New Tab
            </a-menu-item>
            <a-menu-item key="3" @click="setVisibleUpdateAnnualLeave(record)">
              Update annual leave
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px;">
            Options <a-icon type="down" />
          </a-button>
        </a-dropdown>
        <!-- <a-button
          icon="info-circle"
          @click="goToListEmployee(record)"
          class="icon-update"
        >
          Detail
        </a-button> -->
      </div>
      <div slot="footer">
        <a-button type="link" @click="pagination" :disabled="isDisabledPagination" :loading="loading">
          <a-icon type="reload" /> Load more
        </a-button>
      </div>
    </a-table>
  </a-card>
</template>
<script>
import debounce from "lodash/debounce";
import changeAlias from "@/services/changeAlias";
import getQuery from "../data/getData";
import { columnEmployee } from "../Constants/dataColumns";
import AddEmployee from "./addEmployee";
import AddUser from "@/views/configAdmin/user/components/addUser";
import FilterListDrawer from "./filter-list-drawer.vue";
import EditLeaveDay from "./leaveDay/editLeaveDay";

import { updateForCreated } from "@/services/updateOnViewConfig";

const limit = 10;
const startPage = 1;

function getDurationShiftEmployee(employee) {
  return (
    employee?.workShift?.duration ||
    employee?.branchLocation?.mainShift?.duration ||
    1
  );
}

export default {
  components: { AddEmployee, AddUser, FilterListDrawer, EditLeaveDay },
  data() {
    this.onFilter = debounce(this.onFilter, 800);
    return {
      currentPage: startPage,
      isDisabledPagination: false,
      loading: true,
      columnEmployee,
      listEmployee: [],
      filter: {},
      employee: {},
      departmentIds: undefined,
      positionId: undefined,
      gender: undefined,
      keySearch: undefined,
      checkNotFilter: true,
      isDisabledResetFilter: true,
      visibleAddEmployee: false,
      visibleAddUser: false,
      visibleUpdateAnnualLeave: false,
    };
  },
  methods: {
    getDurationShiftEmployee,
    searchFilter(input, option) {
      return (
        changeAlias(option.componentOptions.children[0].text).indexOf(
          changeAlias(input)
        ) >= 0
      );
    },
    onDefaultCurrentPage() {
      this.currentPage = 1;
      this.listEmployee = [];
    },
    goToDetailEmployee(record) {
      this.$router.push({
        name: "detailEmployee",
        params: { idEmployee: record.id },
      });
    },
    goToListEmployee(record) {
      this.$router.push({
        name: "basicInfoEmployee",
        params: { idEmployee: record.id },
      });
    },
    goToListEmployeeInNewTab(record) {
      const routeData = this.$router.resolve({
        name: "basicInfoEmployee",
        params: { idEmployee: record.id },
      });
      window.open(routeData.href, "_blank");
    },
    pagination() {
      this.currentPage += 1;
      this.getAllEmployee();
    },
    checkDisableButtonNotFilter() {
      if (
        !this.filter?.departmentIds &&
        !this.filter?.positionId &&
        !this.filter?.gender &&
        !this.filter?.startedDate &&
        !this.keySearch
      ) {
        this.isDisabledResetFilter = true;
      }
    },
    isFilterEmployees() {
      if (
        !this.filter?.departmentIds &&
        !this.filter?.positionId &&
        !this.filter?.gender &&
        !this.filter?.startedDate &&
        !this.keySearch
      ) {
        return false;
      }
      return true;
    },
    resetFilter() {
      if (this.isFilterEmployees()) {
        this.departmentIds = undefined;
        this.positionId = undefined;
        this.gender = undefined;
        this.keySearch = undefined;
        this.isDisabledPagination = false;
        this.isDisabledResetFilter = true;
        this.filter = {};
        this.onDefaultCurrentPage();
        this.getAllEmployee();
      }
    },
    onFilter(e) {
      this.isDisabledResetFilter = false;
      this.onDefaultCurrentPage();
      this.checkDisableButtonNotFilter();
      this.getAllEmployee();
    },
    getAllEmployee() {
      this.loading = true;
      this.$apollo
        .query({
          query: getQuery.queryGetAllEmployee,
          variables: {
            limit,
            page: this.currentPage,
            query: this.keySearch,
            ...this.filter,
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getAllEmployee?.length >= 0) {
            if (data.getAllEmployee.length < limit) {
              this.isDisabledPagination = true;
            } else {
              this.isDisabledPagination = false;
            }

            this.listEmployee = [
              ...this.listEmployee.concat(data.getAllEmployee),
            ];
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách chức vụ", error);
        });
    },

    updateListAfterCreated(item) {
      this.listEmployee = updateForCreated({
        item,
        list: this.listEmployee,
        limit: limit,
        currentPage: this.currentPage,
      });
    },
    setFilterItem(name, value) {
      this.$set(this.filter, name, value);
    },
    setVisibleUpdateAnnualLeave(record) {
      if (record) {
        this.employee = { ...record };
        this.visibleUpdateAnnualLeave = true;
      } else {
        this.employee = {};
        this.visibleUpdateAnnualLeave = false;
      }
    },
    refreshEmployeeAfterLeaveAnualUpdated(annualLeaveDay) {
      this.listEmployee = this.listEmployee.map((e) =>
        e.id === annualLeaveDay.employeeId ? { ...e, annualLeaveDay } : { ...e }
      );
    },
    showExport() {
      const url = new URL('./#/employee/export', window.location.href);
      console.log(url)
      window.open(url.toString());
    }
  },
  created() {
    this.getAllEmployee();
  },
};
</script>
